export const ACTION_STATUS_OPTIONS = [
  { label: `Review pending`, value: `Review pending`, val: 'review_pending', backgroundColor: 'bg-navy-100', textColor: 'text-white', showLabel: false, },
  { label: `Revision requested`, value: `Revision requested`, val: 'revision_requested',  backgroundColor: 'bg-plum-100', textColor: 'text-white', showLabel: false },
  { label: `Approved`, value: `Approved`, val: 'Approved', backgroundColor: 'bg-sea-100', textColor: 'text-white', showLabel: false },
  { label: `Open - action pending`, value: `Open - action pending`, val: 'open_action_pending',  backgroundColor: 'bg-high', textColor: 'text-white', showLabel: false },
  { label: `Evidence review pending`, value: `Evidence review pending`, val: 'evidence_review_pending', backgroundColor: 'bg-aqua-100', textColor: 'text-navy-100', showLabel: false },
  { label: `Open - in process`, value: `Open - in process`, val: 'open_in_process', backgroundColor: 'bg-lemon-100', textColor: 'text-navy-100', showLabel: false },
  { label: `Tentatively closed - onsite verification required`, value: `Tentatively closed - onsite verification required`, val: 'tentatively_closed_onsite_verification_required', backgroundColor: 'bg-mint-100', textColor: 'text-navy-100', showLabel: false },
  { label: `Closed - desktop verified`, value: `Closed - desktop verified`, val: 'closed_desktop_verified', showLabel: false },
];

export const getCapManagerActionStatusOptions = ( actionReviewMethod, overallCapStatus) => {
  if (overallCapStatus === 'cap_review_pending') {
    return [
      { label: 'Review pending', value: 'Review pending', val: 'review_pending', backgroundColor: 'bg-navy-100', textColor: 'text-white', showLabel: false, isDisabled: true },
      { label: 'Revision requested', value: 'Revision requested', val: 'revision_requested',  backgroundColor: 'bg-plum-100', textColor: 'text-white', showLabel: false },
      { label: 'Approved', value: 'Approved', val: 'Approved', backgroundColor: 'bg-sea-100', textColor: 'text-white', showLabel: false }
    ];
  } 
  if (overallCapStatus === 'cap_evidence_review_pending') {
    const actionStatusOptions = [
      { label: 'Evidence review pending', value: 'Evidence review pending', val: 'evidence_review_pending', backgroundColor: 'bg-aqua-100', textColor: 'text-navy-100', showLabel: false, isDisabled: true },
      { label: 'Open - in process', value: 'Open - in process', val: 'open_in_process', backgroundColor: 'bg-lemon-100', textColor: 'text-navy-100', showLabel: false },
    ];

    if (actionReviewMethod === 'onsite') {
      return [ ...actionStatusOptions, { label: 'Tentatively closed - onsite verification required', value: 'Tentatively closed - onsite verification required', val: 'tentatively_closed_onsite_verification_required', backgroundColor: 'bg-mint-100', textColor: 'text-navy-100', showLabel: false } ];
    }
    return [ ...actionStatusOptions, { label: 'Closed - desktop verified', value: 'Closed - desktop verified', val: 'closed_desktop_verified', showLabel: false } ];
  }

  return [];
};

export const ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES = [
  {value: 'hours', label: 'Hours'},
  {value: 'days', label: 'Days'},
  {value: 'weeks', label: 'Weeks'},
  {value: 'months', label: 'Months'}
];

export const ACTION_RESOURCE_TYPE_VALUES = {
  investment: 'investment',
  numberOfStaffDays: 'number_of_staff_days'
};

export const ACTION_RESOURCE_INVESTMENT_DEFAULT_VALUES = {  
  resourceType: 'investment',
  details: '',
  currencyId: null,
  costs: null
};

export const ACTION_RESOURCE_NUMBER_OF_STAFF_DEFAULT_VALUES = {
  resourceType: 'number_of_staff_days',
  details: '',
  numberOfStaff: null,
  staffDayType: null,
  staffDayValue: null,
  currencyId: null,
  averageDayRate: null,
  costs: null
};

export const actionItemsEditable = (status, id, originalActionStatus, isCapManager, isAdmin, editableForExternalUser, overallCapStatus, capType) =>{
  /* Fields:  Due Date, Completion Date, Responsible Person, Description, Attachment, Delete */
  /* Editable when factory user action status is Null or Revision Requested, Cap Manager cannot edit */
  const EXTERNAL_USER_ACTION_REFERENCE_EDITABLE_ACTION_STATUS = ['pending', 'revision_requested']; 
  const EXTERNAL_USER_ACTION_REFERENCE_EDITABLE_ACTION_STATUS_DESKTOP_EVIDENCE_REVIEW = ['open_action_pending', 'open_in_process']; 
  const EXTERNAL_USER_ACTION_REFERENCE_EDITABLE_OVERALL_CAP_STATUS = ['cap_submission_pending', 'cap_revision_request'];
  const EXTERNAL_USER_ACTION_REFERENCE_EDITABLE_OVERALL_CAP_STATUS_DESKTOP_EVIDENCE_REVIEW = ['cap_remediation_underway']

  const editableActionStatus = capType === 'desktop_evidence_review' 
  ? EXTERNAL_USER_ACTION_REFERENCE_EDITABLE_ACTION_STATUS_DESKTOP_EVIDENCE_REVIEW 
  : EXTERNAL_USER_ACTION_REFERENCE_EDITABLE_ACTION_STATUS;

  const editableOverallCapStatus = capType === 'desktop_evidence_review' 
  ? EXTERNAL_USER_ACTION_REFERENCE_EDITABLE_OVERALL_CAP_STATUS_DESKTOP_EVIDENCE_REVIEW 
  : EXTERNAL_USER_ACTION_REFERENCE_EDITABLE_OVERALL_CAP_STATUS;

  const actionReference = editableForExternalUser ? (!status || !originalActionStatus || !id || (editableActionStatus.includes(status?.toLowerCase()) && editableOverallCapStatus.includes(overallCapStatus?.toLowerCase())))  : false;
  
  /* Fields: Action Status dropdown */
  /* Editable for Cap Manager when status is Review pening, Evidence Review Pending, Factory User cannot edit */
  const CAPMANAGER_ACTION_STATUS_DROPDOWN_EDITABLE_ACTION_STATUS = ['review_pending', 'evidence_review_pending'];
  const CAPMANAGER_ACTION_STATUS_DROPDOWN_EDITABLE_OVERALL_CAP_STATUS = ['cap_review_pending', 'cap_evidence_review_pending'];
  const actionStatus = isCapManager ? (CAPMANAGER_ACTION_STATUS_DROPDOWN_EDITABLE_ACTION_STATUS.includes(originalActionStatus?.toLowerCase()) || CAPMANAGER_ACTION_STATUS_DROPDOWN_EDITABLE_OVERALL_CAP_STATUS.includes(overallCapStatus?.toLowerCase())) : false;

  /* Fields: Comments and Resources */
  /* Editable for Factory user when status is Null or Review Requested or Open Action Pending or Open in process, */ 
  /* CapManagor cannot edit resources */
  /* but can edit in  Review pening, Evidence Review Pending, */  
  const EXTERNAL_USER_COMMENTS_EDITABLE_ACTION_STATUS = ['pending', 'revision_requested', 'open_action_pending', 'open_in_process'];
  const EXTERNAL_USER_COMMENTS_EDITABLE_OVERALL_CAP_STATUS = ['cap_submission_pending', 'cap_revision_request', 'cap_remediation_underway'];
  const factoryUserCommentsOrResource = (!status || !originalActionStatus || !id || (EXTERNAL_USER_COMMENTS_EDITABLE_ACTION_STATUS.includes(status?.toLowerCase()) && EXTERNAL_USER_COMMENTS_EDITABLE_OVERALL_CAP_STATUS.includes(overallCapStatus?.toLowerCase())) ) ;

  /* Fields: Delete */
  /* Factory user - Hide delete when status is Approved or Open - Action pending or Evidence review pending or Open - In process or ‘tentatively closed - onsite verification required' or ‘closed - desktop verified */  
  /* CapManager cannot delete so hide  */
  const EXTERNAL_USER_HIDE_DELETE = ['approved', 'open_action_pending', 'evidence_review_pending', 'open_in_process', 'tentatively_closed_onsite_verification_required', 'closed_desktop_verified'];
  const EXTERNAL_USER_HIDE_DELETE_DESKTOP_EVIDENCE_REVIEW = ['approved', 'evidence_review_pending', 'tentatively_closed_onsite_verification_required', 'closed_desktop_verified'];
  const EXTERNAL_USER_HIDE_DELETE_OVERALL_CAP_STATUS = ['cap_remediation_underway', 'cap_evidence_review_pending', 'cap_remediation_underway', 'cap_process_complete_on_site_verification_pending', 'cap_process_complete_all_findings_closed'];
  const statusesForHideDelete = capType === 'desktop_evidence_review'? EXTERNAL_USER_HIDE_DELETE_DESKTOP_EVIDENCE_REVIEW : EXTERNAL_USER_HIDE_DELETE
  const hideDelete = isCapManager 
  ? true 
  : (statusesForHideDelete.includes(status?.toLowerCase()) && EXTERNAL_USER_HIDE_DELETE_OVERALL_CAP_STATUS.includes(overallCapStatus?.toLowerCase()))
  
  return {
    actionReference: isAdmin || actionReference,
    actionStatus: isAdmin || actionStatus,
    comments: isAdmin || (editableForExternalUser ? factoryUserCommentsOrResource : actionStatus),
    attachments: isAdmin || (editableForExternalUser ? factoryUserCommentsOrResource : false),
    resources: isAdmin || (editableForExternalUser ? factoryUserCommentsOrResource : false),
    hideDelete:  isAdmin ? false : hideDelete
  }
};

